import { defineStore } from 'pinia'
interface typesState {
  defaultTypes: any
  resultTypes: any
  activeType: number | string
  dateGroup: any
  clarityGroup: any
  durationGroup: any
  currentDate: number | string
  currentClarity: number | string
  currentDuration: number | string
  filtersStatus:boolean,
  isFilterClicked:boolean,
}
export const useTypesStore = defineStore('typesStore', {
  state: (): typesState => {
    return {
      defaultTypes: [],
      resultTypes: [],
      activeType: '',
      dateGroup: [
        {
          name: '全部',
          val: ''
        },
        {
          name: '今天',
          val: '1'
        },
        {
          name: '昨天',
          val: '2'
        },
        {
          name: '近7天',
          val: '3'
        },
        {
          name: '近30天',
          val: '4'
        }
      ],
      clarityGroup: [
        {
          name: '全部',
          val: ''
        },
        {
          name: '高清',
          val: '1'
        },
        {
          name: '超清',
          val: '2'
        }
      ],
      durationGroup: [
        {
          name: '全部',
          val: ''
        },
        {
          name: '2分钟',
          val: '1'
        },
        {
          name: '10分钟',
          val: '2'
        },
        {
          name: '30分钟',
          val: '3'
        },
        {
          name: '1小时以上',
          val: '4'
        }
      ],
      currentDate: 0,
      currentClarity: 0,
      currentDuration: 0,
      filtersStatus:false,
      isFilterClicked:false,
    }
  },
  actions: {}
  // 开始数据持久化
  // persist: process.client && {
  //   key: 'searchData',
  //   storage: process.client && window.localStorage
  // }
})
